import React from 'react';
import './common-toaster.scss';

const CommonToaster = ({ message, toaster }) => {
  return (
    <div className="sticky-toaster-common">
      {toaster ? (
        <div className="report-toaster report-toaster-pos">
          {!message.isError && (
            <span>
              <i className="eva eva-checkmark-outline"></i>
            </span>
          )}
          {message.isError && (
            <div className="icon-error">
              <i className="eva eva-close-outline"></i>
            </div>
          )}
          {message?.message}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default CommonToaster;
